import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { keycloakInstance, ensureKeycloakInitialized } from '../../keycloak.config';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { FlexLayoutModule } from '@angular/flex-layout';


@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule,MatCardModule,MatCheckboxModule,MatButtonModule,FlexLayoutModule],
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {
  isAuthenticated = false;
  
  showTerms = true;
  currentStep = 1;
 
  

  
  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit(): Promise<void> {
    console.log('Landing page component initializing');
    
    // Initialize terms content
    
    
    // Ensure change detection runs after initializing content
    this.cdr.detectChanges();
    
    // Check if the user is already authenticated
    setTimeout(async () => {
      await this.checkAuthAndRedirect();
    }, 300);
  }

  async checkAuthAndRedirect(): Promise<void> {
    console.log('Landing page checking auth state');
    
    try {
      // First check if already initialized and authenticated
      if (keycloakInstance.didInitialize) {
        console.log('Keycloak already initialized, checking auth state');
        if (keycloakInstance.authenticated) {
          console.log('User already authenticated, redirecting immediately');
          this.isAuthenticated = true;
          this.router.navigate(['/input-meters']);
          return;
        }
      }
      
      // Otherwise do the full initialization
      const authenticated = await ensureKeycloakInitialized();
      
      console.log('Landing page auth check result:', authenticated);
      this.isAuthenticated = authenticated;
      
      // If authenticated, redirect immediately without setTimeout
      if (authenticated) {
        console.log('Landing page redirecting to input-meters');
        this.router.navigate(['/input-meters']);
      }
    } catch (error) {
      console.error('Error checking authentication in landing page:', error);
    }
  }


  login(): void {
    
    try {
      // Ensure Keycloak is initialized first
      ensureKeycloakInitialized().then(() => {
        console.log('Logging in with Keycloak');
          keycloakInstance.login({
            redirectUri: window.location.origin + '/input-meters'
        });
        });
      } catch (error) {
        console.error('Login error:', error);
    }
  }
}